import { createContext, useContext, useState } from 'react';

interface SidebarContextValue {
  collapsed: boolean;
  // Setter explicite plutôt qu'un simple toggle() : RepoViewPage.tsx a besoin de connaître la
  // valeur exacte qu'il vient de poser pour la persister par compte (voir
  // sidebarCollapsedMutation) — un toggle() aveugle ne le permettrait pas sans dupliquer l'état.
  setCollapsed: (value: boolean) => void;
}

const SidebarContext = createContext<SidebarContextValue>({
  collapsed: false,
  setCollapsed: () => {},
});

export function SidebarProvider({ children }: { children: React.ReactNode }) {
  const [collapsed, setCollapsed] = useState(false);
  return (
    <SidebarContext.Provider value={{ collapsed, setCollapsed }}>
      {children}
    </SidebarContext.Provider>
  );
}

export function useSidebar() {
  return useContext(SidebarContext);
}
